/* eslint-disable react/destructuring-assignment */

import * as React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import * as NotificationHelper from '../../helpers/notificationHelper';

import styles from './aegisubAudioToVideoConverter.module.scss';

const DEFAULT_PROCESSED_MESSAGE = 'Please paste data in the left column';

interface InnerState {
  processedData: string;
}

export class AegisubAudioToVideoConverter extends React.Component<{}, InnerState> {
  private static processDataForVideo(audioData: string) {
    const lines = audioData.split('\n');

    const processedLines = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const line of lines) {
      processedLines.push(line);
      const lineParts = line.split(',');
      lineParts[lineParts.length - 1] = '';
      processedLines.push(lineParts.join(','));
    }

    return processedLines.join('\n');
  }

  public constructor(props: any) {
    super(props);
    this.state = {
      processedData: DEFAULT_PROCESSED_MESSAGE,
    };
  }

  private onDataCopyClicked() {
    NotificationHelper.success('Data copied!');
  }

  private dataChanged = (a: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = a.target;
    this.setState({
      processedData:
        value && value !== ''
          ? AegisubAudioToVideoConverter.processDataForVideo(a.target.value)
          : DEFAULT_PROCESSED_MESSAGE,
    });
  };

  public render() {
    return (
      <div className={styles.toolWrapper}>
        <div className={styles.textAreaWrapper}>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>Paste data resulting from Aegisub Audio clipping here</label>
          <textarea onChange={this.dataChanged} />
        </div>
        <div className={styles.textAreaWrapper}>
          <CopyToClipboard text={this.state.processedData}>
            {/* eslint-disable-next-line react/button-has-type */}
            <button onClick={this.onDataCopyClicked} className={styles.copy}>
              Copy the data here into Aegisub to start video clipping
            </button>
          </CopyToClipboard>
          <textarea disabled value={this.state.processedData} />
        </div>
      </div>
    );
  }
}
